import { forwardRef } from "react";
import { NumericFormat, NumericFormatProps } from "react-number-format";
import { felixTokens } from "../../../../theme";
type Props = {
  onChange: (event: {
    target: {
      name: string;
      value: string;
      floatValue?: number;
      formattedValue: string;
    };
  }) => void;
  name: string;
};
const MoedaInput = forwardRef<NumericFormatProps, Props>(function MoedaInput(
  props,
  ref
) {
  const { onChange, ...other } = props;

  // Defaults ANTES do spread: quem usa pode trocar prefix (moeda estrangeira
  // no ponto de partida internacional) e decimalScale. Antes o "R$ " fixo
  // vinha depois e sobrescrevia o prefix passado por inputProps.
  return (
    <NumericFormat
      decimalScale={2}
      prefix="R$ "
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
            floatValue: values.floatValue,
            formattedValue: values.formattedValue,
          },
        });
      }}
      // Campo de valor: alinhado à direita e em mono tabular, igual à coluna
      // de tabela onde esse número vai parar.
      style={{
        textAlign: "right",
        fontFamily: felixTokens.fontMono,
        fontVariantNumeric: "tabular-nums",
      }}
      thousandSeparator="."
      decimalSeparator=","
      fixedDecimalScale
      valueIsNumericString
    />
  );
});

export default MoedaInput;
